import type { FC } from "react"

import styled from "styled-components"

const Spinner = styled.div`
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 3px solid var(--blue);
  border-radius: 50%;
  border-top-color: var(--cyan-2-faded);
  animation: spin 1.5s ease-in-out infinite;
  -webkit-animation: spin 1.5s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`

const GreySpinner = styled.div`
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 3px solid var(--grey-dark);
  border-radius: 50%;
  border-top-color: var(--grey-light);
  animation: spin 1.5s ease-in-out infinite;
  -webkit-animation: spin 1.5s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`

export const SimpleLoader: FC<{ greyScale?: boolean }> = ({ greyScale }) => {
  return greyScale ? <GreySpinner /> : <Spinner />
}

export default SimpleLoader
